import heic2any from "heic2any";
import EXIF from "exif-js";

export const convertHeicToJpg = async (file) => {
  // HEIC画像の場合はjpegに変換してから読み込む
  if (/heic/.test(file.type)) {
    return await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.5,
    });
  } else {
    return file;
  }
};

// バージョンを取得
function ipad_ios_version() {
  var version = "0";
  if (navigator.userAgent.match(/(iPhone|iPad|iPod)/)) {
    version = navigator.userAgent.match(/OS ((\d+_?){2,3})\s/)[1];
  }
  return parseFloat(version.replace("_", ".").substring(0, 4));
}

function base64ToFile(data) {
  try {
    let separetedDate = data.split(",");
    let mimeTypeData = separetedDate[0].match(/:(.*?);/);
    let mimeType = Array.isArray(mimeTypeData) ? mimeTypeData[0] : "";
    let decodedData = atob(separetedDate[1]);
    let dataLength = decodedData.length;
    let arrayBuffer = new ArrayBuffer(dataLength);
    let u8arr = new Uint8Array(arrayBuffer);

    for (let i = 0; i < dataLength; i += 1) {
      u8arr[i] = decodedData.charCodeAt(i);
    }

    return new Blob([u8arr], { type: mimeType });
  } catch (errors) {
    console.log(errors);
    return new Blob([]);
  }
}

const convertToJpeg = async (imageData, file, msg2mbCheck) => {
  return await new Promise((resolve) =>
    // ファイルのExif情報を取得
    EXIF.getData(file, function () {
      // 画像サイズ圧縮率（TG-CARSモバイルと同様）
      const oldKikiImgCompression = 0.4; // 40%
      // 画像品質圧縮率（TG-CARSモバイルと同様）
      const oldKikiImgQuality = 0.5; // 50%
      // 回転方向を取得
      var orientation = EXIF.getTag(this, "Orientation");

      // iOSバージョンが13.4以上の場合、画像の調整を行わない
      if (ipad_ios_version() >= 13.4) orientation = 1;

      // iPadOSのsafariの場合、画像の調整を行わない
      if (
        navigator.userAgent.match(/(Macintosh)/) &&
        navigator.standalone !== undefined
      ) {
        orientation = 1;
      }

      // ファイル出力用Imageタグ生成
      var img = new Image();
      // 画像ロード出力イベント追加
      img.src = imageData;
      img.addEventListener("load", function () {
        // 画像回転・圧縮用キャンパス生成
        const canvas = document.createElement("canvas");

        const ctx = canvas.getContext("2d");
        // 回転方向を判断
        if ([5, 6, 7, 8].indexOf(orientation) > -1) {
          // 回転されているため、縦横サイズを反転・画像リサイズ
          canvas.width = img.height * oldKikiImgCompression;
          canvas.height = img.width * oldKikiImgCompression;
        } else {
          // 回転されていない為、縦横サイズはそのまま・画像リサイズ
          canvas.width = img.width * oldKikiImgCompression;
          canvas.height = img.height * oldKikiImgCompression;
        }

        // 回転方向・圧縮率に従い、キャンパスを変形させる
        switch (orientation) {
          case 1:
            ctx.transform(1, 0, 0, 1, 0, 0);
            break; // 変形を行わない
          case 2:
            ctx.transform(-1, 0, 0, 1, img.width * oldKikiImgCompression, 0);
            break;
          case 3:
            ctx.transform(
              -1,
              0,
              0,
              -1,
              img.width * oldKikiImgCompression,
              img.height * oldKikiImgCompression
            );
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, img.height * oldKikiImgCompression);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, img.height * oldKikiImgCompression, 0);
            break;
          case 7:
            ctx.transform(
              0,
              -1,
              -1,
              0,
              img.height * oldKikiImgCompression,
              img.width * oldKikiImgCompression
            );
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, img.width * oldKikiImgCompression);
            break;
          default:
        }

        // キャンパスへ画像を描画
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          img.width * oldKikiImgCompression,
          img.height * oldKikiImgCompression
        );

        // 画像Base64値を取得
        const base64 = canvas.toDataURL("image/jpeg", oldKikiImgQuality);

        // 2MBチェックを行う
        var base64FileSize = base64ToFile(base64).size;
        if (base64FileSize >= 2000000) {
          // メッセージ「2MB以下の画像を選択してください。」
          msg2mbCheck();
          return;
        }

        // 画面表示サイズを設定
        var imgHeight = canvas.height;
        var imgWidth = canvas.width;
        var maxImgSize = 200;

        if (imgHeight >= imgWidth) {
          imgHeight = maxImgSize;
          imgWidth = imgWidth * (maxImgSize / canvas.height);
        } else {
          imgWidth = maxImgSize;
          imgHeight = imgHeight * (maxImgSize / canvas.width);
        }

        resolve(base64);
      });
    })
  );
};

export const getBase64 = async (file, msg2mbCheck) => {
  if (!file) return null;

  return await new Promise((resolve) => {
    let reader = new FileReader();
    reader.onloadend = async () => {
      const res = reader.result;
      if (res && typeof res === "string") {
        resolve(convertToJpeg(res, file, msg2mbCheck));
        // base64.replace(/^.*,/, "");
      }
    };
    // HEIC画像の場合はjpegに変換してから読み込む
    if (/heic/.test(file.type)) {
      heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.5,
      }).then((resultBlob) => {
        file = new File([resultBlob], "test.jpeg", { type: "image/jpeg" });
        reader.readAsDataURL(file);
      });
    } else {
      reader.readAsDataURL(file);
    }
  });
};
